import gql from 'graphql-tag'

export default gql`
  query GetCart($id: UUID) {
    cart(id: $id) {
      ... on Cart {
        id
        cartAmount
        currency
        items {
          id
          productId
          sku
          salesPrice
          category
          name
          image {
            url
            description
          }
          ... on GenericCartItem {
            quantity
            description
            options {
              name
              id
              value
            }
          }
          ... on GiftCardCartItem {
            value
            recipientDetails {
              recipientName
              message
              ... on VirtualRecipientDetails {
                recipientEmail
                senderName
                deliveryDate
                deliveryMethod
              }
            }
          }
        }
        marketplaceItems {
          id
          sku
          variantGroupCode
          brand
          category {
            path {
              code
              title
            }
          }
          shop {
            retailer {
              sys {
                id
              }
            }
            id
            name
          }
          name
          listPrice
          discountPrice
          quantity
          image {
            url
            description
          }
          optionValues {
            id
            optionId
            displayName
            value
          }
          variant {
            quantity
            returnable
          }
          issues {
            type
            severity
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`
